import {
    CloseIcon,
    InputOtp, Modal,
    ModalBg,
    ModalContent,
    Title
} from "../TwoFA/style";
import {
    Body,
    Footer, FormButton2, Head, OtpDesc, OtpTitle,
} from "./style";

import {ContainerRow} from "../Container";
import React, {useEffect, useState} from "react";
import {useApp} from "../../contexts";
import {
    getTwoFactorStep2, postEmailCodeVerify, postSentEmailCodeVerify, validateEmail
} from "../../services/app";
import {AuthFormInput2, AuthFormInputSpan2} from "../../pages/withdraw/modal/styles";
import produce from "immer";

export const SocialEmail = (props) => {
    const {T, setUser, user, setAlert, setLoading, popup, setPopup} = useApp();
    const [otp, setOtp] = useState('');
    const [email, setEmail] = useState('');
    const [send, setSend] = useState(false);
    const [errors, setErrors] = useState([]);

    const onSubmit = async () => {
        setLoading(true);
        const result = await postEmailCodeVerify(otp);
        setLoading(false);
        if (result.status === 200) {
            setAlert({type: 'success', text: T("Succeeded")});
            // reload user
            setUser({token: user.token, reload: Date.now()});
        } else {
            setAlert({type: 'error', text: result?.data?.error?.message});
        }
    }

    const onClose = () => {
        setUser({});
    }

    async function onSentOtp() {
        setLoading(true);
        if (!email?.trim() || !validateEmail(email)) {
            setLoading(false);
            setAlert({type: 'error', text: T("Invalid email address!")});
            return;
        }
        const result = await postSentEmailCodeVerify(email);
        setLoading(false);

        if (result.status === 200) {
            setAlert({type: 'success', text: T("Succeeded")});
            setSend(true);
        } else {
            setAlert({type: 'error', text: result?.data?.error?.message});
        }
    }

    return !user?.email && !!user?.token && !!user?.id ? (
        <Modal>
            <ModalBg onClose={() => onClose()} />
            <ModalContent>
                <Head>
                    <Title>{T("One more step")}</Title>
                    <CloseIcon onClick={() => onClose()} className={'close'}/>
                </Head>

                <Body style={{alignItems: "center"}}>
                    <OtpDesc>{T("Your email is required to perform this action. Please fill your email and input the code we send to your email.")}</OtpDesc>

                    <div style={{position: "relative", width: '100%'}}>
                        <AuthFormInput2 value={email} onChange={event => {
                            setEmail(event.target.value);
                            setErrors(produce(draft => {
                                draft.splice(draft.findIndex(item => item.key === 'email'), 1)
                            }));
                        }} placeholder={T("Input your email")}/>
                        <AuthFormInputSpan2 className={'send-code'} style={{top: 12}}
                                            onClick={onSentOtp}>{T("Get code")}</AuthFormInputSpan2>
                    </div>

                    {
                        send ? (
                            <>
                                <OtpTitle>{T("Input 6-digit code")}</OtpTitle>
                                <InputOtp value={otp} onChange={(event) => {
                                    setOtp(event)
                                }}/>
                            </>
                        ) : null
                    }
                </Body>
                <Footer>
                    <ContainerRow>
                        <FormButton2 disabled={!(email && otp)} onClick={() => onSubmit()}>{T("Verify")}</FormButton2>
                    </ContainerRow>
                </Footer>
            </ModalContent>
        </Modal>
    ) : null;
}